export default "__VITE_ASSET__9xWLBZwU__"